import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import useTranslation from '../../hooks/useTranslation';
import { IconExternal } from '../Icons';

function HeaderMenu({ closeExpanded }) {
    const { t, links } = useTranslation();
    const location = useLocation();

    // Get menu items from config
    const menuItems = t('menu.items', [
        { path: '/', label: 'Tracker', icon: 'map' },
        { path: '/menu', label: 'Menukaart', icon: 'menu' },
        { path: '/info', label: 'Info', icon: 'info' }
    ]);

    const reserveLabel = t('menu.reserveCta', 'Reserveer');
    // Per-tenant: no reservation URL configured -> no reserve button (e.g. Joris
    // IJs runs a tracker-only app without reservations).
    const reserveUrl = links?.reservation || '';

    return (
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            {menuItems.map((item) => (
                <Link
                    key={item.path}
                    className={`nav-item nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    to={item.path}
                    onClick={closeExpanded}
                >
                    {item.label}
                </Link>
            ))}
            {reserveUrl && (
                <a
                    className="reserve-cta"
                    href={reserveUrl}
                    target="_blank"
                    rel="noreferrer"
                    onClick={closeExpanded}
                    title={t('menu.reserveExternal', 'Opent de reservatiepagina in een nieuw tabblad')}
                >
                    {reserveLabel}
                    <IconExternal size={14} className="reserve-cta-external" />
                </a>
            )}
        </div>
    );
}

export default HeaderMenu;
